/** Mobile horizontal gutter — aligns Finished label, tabs, and panel content (10px). */
export const MATCH_DETAIL_MOBILE_INSET_X = "px-[10px]";

/** Shared desktop page gutter for match-play chrome, scoreboard, and lobby content.
 * Caps at the site shell (1280px) and matches Trader markets / main header inset. */
export const MATCH_PLAY_DESKTOP_PAGE_GUTTER_CLASS =
    "mx-auto box-border w-full min-w-0 max-w-[1280px] md:px-7 lg:px-10 xl:px-0";

/** Shared horizontal inset for match detail tabs and panel content. Caps + centers content
 * at the site shell width (1280px) so section backgrounds stay full-bleed while content is inset. */
export const MATCH_DETAIL_INSET_X = "mx-auto w-full max-w-[1280px] px-[10px] md:px-7 lg:px-10 xl:px-12 2xl:px-14";

/** Desktop-only horizontal inset — aligns tab panel content with the tab bar (lg+). */
export const MATCH_DETAIL_DESKTOP_INSET_X = "lg:mx-auto lg:w-full lg:max-w-[1280px] lg:px-10 xl:px-12 2xl:px-14";

/** Sticky team/score header inset — desktop centers + caps the white card on the gradient
 * (mobile stays full-bleed), matching the cricket match detail header. */
export const MATCH_DETAIL_HEADER_DESKTOP_INSET =
    "md:mx-auto md:w-full md:max-w-[1280px] md:px-7 md:pb-2 md:pt-5 lg:px-10 lg:pb-3 lg:pt-6 xl:px-12 2xl:px-14";

/** Tennis match detail — tighter mobile gutter; desktop matches shared tab shell. */
export const TENNIS_MATCH_DETAIL_INSET_X = "mx-auto w-full max-w-[1280px] px-2 sm:px-3 lg:px-10 xl:px-12 2xl:px-14";

/** Desktop two-column split (main tabs left, stats / play rail right). */
export const MATCH_DETAIL_DESKTOP_GRID_COLS =
    "lg:grid-cols-[1.35fr_1fr] xl:grid-cols-[1.5fr_1fr] 2xl:grid-cols-[1.7fr_1fr] min-[1600px]:grid-cols-[1.85fr_1fr]";

/** Narrower play rail for non-cricket match detail (football, tennis, horses — typically Trader-only). */
export const MATCH_DETAIL_DESKTOP_GRID_COLS_NARROW_PLAY_RAIL =
    "lg:grid-cols-[minmax(0,1fr)_minmax(260px,320px)] xl:grid-cols-[minmax(0,1fr)_minmax(280px,340px)] 2xl:grid-cols-[minmax(0,1fr)_minmax(300px,360px)]";

export const MATCH_DETAIL_DESKTOP_GRID_GAP = "lg:gap-4 xl:gap-6";

/** Desktop split inside Events tab (commentary left, stats + H2H right). */
export const MATCH_DETAIL_EVENTS_CONTEXT_GRID_COLS =
    "lg:grid-cols-[minmax(0,1.45fr)_minmax(0,1fr)] xl:grid-cols-[minmax(0,1.5fr)_minmax(0,1fr)]";

/** Inner panel content padding — horizontal inset comes from the tab shell. */
export const MATCH_DETAIL_PANEL_CONTENT_CLASS = "min-h-0 px-0 pb-[10px] pt-4 lg:pb-4 lg:pt-6";

/** Panel body when desktop top spacing is applied by MatchDetailSplitPanels grid. */
export const MATCH_DETAIL_PANEL_INNER_CLASS = "min-h-0 px-0 pb-[10px] pt-4 lg:pb-4 lg:pt-0";

/** Counteract tab-shell inset so match-detail panels (TABLE, stats, etc.) run edge-to-edge below lg. */
export const MATCH_DETAIL_MOBILE_BLEED_CLASS =
    "max-lg:-mx-[10px] max-lg:w-[calc(100%+20px)] md:max-lg:-mx-7 md:max-lg:w-[calc(100%+3.5rem)]";

/** @deprecated Use MATCH_DETAIL_MOBILE_BLEED_CLASS */
export const MATCH_DETAIL_TABLE_MOBILE_BLEED_CLASS = MATCH_DETAIL_MOBILE_BLEED_CLASS;

/** Full-bleed panel surface — drop side borders on narrow viewports when bleeding full width. */
export const MATCH_DETAIL_MOBILE_BLEED_SURFACE_CLASS = "max-lg:border-x-0 max-lg:shadow-none";

/** @deprecated Use MATCH_DETAIL_MOBILE_BLEED_SURFACE_CLASS */
export const MATCH_DETAIL_TABLE_MOBILE_SURFACE_CLASS = MATCH_DETAIL_MOBILE_BLEED_SURFACE_CLASS;

/** Desktop Events split columns — surface only; row/grid parents supply top spacing. */
export const MATCH_DETAIL_EMBED_COLUMN_CLASS = "min-h-0 w-full self-start";
